// React
import React, { cloneElement, useState } from "react";

// MUI
import { Dialog, DialogContent, DialogTitle } from "@mui/material";

// Components
import SimpleIconButton from "@Layouts/components/Buttons/SimpleIconButton";

// Icons
import CloseIcon from "@mui/icons-material/Close";

// Types
import { CustomCredentials } from "@Settings/types/administrationTools/utils";

type ProviderLoginDialogProps<TData extends CustomCredentials> = Readonly<{
	isSigningIn: boolean;
	children: React.ReactElement;
	isError: boolean;
	error: Error | null;
	isSuccess?: boolean;
	title?: string;
	headerImage?: string;
	// Callbacks
	isOpen: boolean;
	onOpen?: () => void;
	onClose: () => void;
	resetLoginError: () => void;
	onSubmit: (data: TData) => void;
}>;

export default function FormLoginDialog<TData extends CustomCredentials>(props: ProviderLoginDialogProps<TData>) {
	const { children, title = "Log in to", headerImage = "", onSubmit = () => {} } = props;

	const [submitted, setSubmitted] = useState(false);

	const isOpen = props.isOpen || (submitted && props.isError); //|| props.isSigningIn;

	const handleCloseDialog = () => {
		props.onClose();
		setSubmitted(false);
	};

	return (
		<Dialog open={isOpen} classes={{ paper: "!w-[345px] !relative !px-2 !pb-7 !pt-3 !rounded-[10px]" }} onClose={handleCloseDialog}>
			<DialogTitle classes={{ root: "!text-lg !text-center !font-montserrat !font-medium !text-default" }}>
				{title}
				<SimpleIconButton
					className={"!absolute top-0 right-0"}
					aria-label="close"
					onClick={props.onClose}
					icon={<CloseIcon className=" !text-[#B3B3B3]" />}
				/>
			</DialogTitle>
			<DialogContent>
				<form
					autoComplete={"off"}
					onSubmit={(event) => {
						event.preventDefault();
						const formData = new FormData(event.currentTarget);
						const formJson = Object.fromEntries(formData.entries());
						onSubmit(formJson as unknown as TData); // Cast formJson to TData
						setSubmitted(true);
					}}
				>
					{headerImage && <img src={headerImage} className={"w-full"} alt={"provider-logo-img"} />}
					{cloneElement(children)}
				</form>
			</DialogContent>
		</Dialog>
	);
}
